import React from 'react';
import Hero from './components/exam-form/Hero';
import Main from './components/exam-form/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const ExamForm = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default ExamForm;